import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface UserSelectionListItem {
  id: string;
  primaryText: string;
  secondaryText?: string;
  meta?: string[];
}

@Component({
  selector: 'app-user-selection-list',
  templateUrl: './user-selection-list.component.html',
  styleUrls: ['./user-selection-list.component.css'],
})
export class UserSelectionListComponent {
  @Input() users: UserSelectionListItem[] = [];
  @Input() disabled = false;
  @Input() isSelected: (userId: string) => boolean = () => false;

  @Output() toggleSelection = new EventEmitter<{ userId: string; checked: boolean }>();

  trackByUserId(_: number, user: UserSelectionListItem): string {
    return user.id;
  }

  onToggle(userId: string, checked: boolean): void {
    this.toggleSelection.emit({ userId, checked });
  }
}
